import { contagemPorStatus } from '@/agenda/visoes';

/**
 * O mês, em calendário (VF-2).
 *
 * ★ NÃO LISTA HORÁRIO. Com centenas de consultas possíveis no mês, listar é
 * ilegível — a célula traz **vagas livres** e o movimento do dia. A pergunta da
 * visão mensal é "que semana tem espaço", e por isso clicar num dia abre a
 * SEMANA, não o dia.
 *
 * ⚠ Os mesmos três estados da semana, com os mesmos rótulos: fechado (com
 * motivo), sem vaga configurada, e livre. Um dia sem grade nenhuma não pode
 * parecer um dia vazio à espera de agendamento.
 */

const DIAS = ['seg', 'ter', 'qua', 'qui', 'sex', 'sáb', 'dom'];

export default function MesAgenda({ semanas, resumoDe, porDia, aoEscolherSemana }) {
  return (
    <div className="tabela-envolve">
      <table className="tabela">
        <thead>
          <tr>{DIAS.map((d) => <th key={d}>{d}</th>)}</tr>
        </thead>
        <tbody>
          {semanas.map((semana, i) => (
            <tr key={semana[0].data.toISOString()}>
              {semana.map(({ data, doMes }) => {
                const resumo = resumoDe(data);
                const doDia = porDia.get(resumo.chave) ?? [];
                const contagem = contagemPorStatus(doDia);
                return (
                  <td
                    key={resumo.chave}
                    className={doMes ? undefined : 'linha-apagada'}
                    onClick={() => aoEscolherSemana(data)}
                  >
                    <strong>{data.getDate()}</strong>
                    {!doMes ? null : resumo.fechado ? (
                      <div className="campo-ajuda">
                        {resumo.motivo ? `fechado — ${resumo.motivo}` : 'fechado'}
                      </div>
                    ) : resumo.vagas === 0 ? (
                      <div className="campo-ajuda">sem vaga</div>
                    ) : (
                      <>
                        <div className="campo-ajuda">
                          {resumo.livres} livre{resumo.livres === 1 ? '' : 's'} de {resumo.vagas}
                        </div>
                        {doDia.length > 0 && (
                          <div className="campo-ajuda">
                            {contagem.agendado > 0 && `${contagem.agendado} marcada${contagem.agendado === 1 ? '' : 's'}`}
                            {contagem.compareceu > 0 && ` · ${contagem.compareceu} veio`}
                            {contagem.faltou > 0 && ` · ${contagem.faltou} faltou`}
                          </div>
                        )}
                      </>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
